export default class {
	constructor(options) {
		const scopeThis = this;
		this.defaults = {
			$el: null,
		};

		this.options = {};
		this.isScrolling = false;
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPS_Swipefree";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			const scopeThis = this;
			this.scrollContainer = this.$el.querySelector(".swiper-wrapper");
			this.prevButton = this.$el.parentNode.querySelector(
				".swipefree-nav-button--prev"
			);
			this.nextButton = this.$el.parentNode.querySelector(
				".swipefree-nav-button--next"
			);

			const scrollAmount = this.$el.offsetWidth;

			if (this.prevButton) {
				this.prevButton.addEventListener("click", () => {
					scopeThis.jsScroll(false);
				});
			}

			if (this.prevButton) {
				this.nextButton.addEventListener("click", () => {
					scopeThis.jsScroll(true);
				});
			}

			if (this.$el.classList.contains("explore__carousel")) {
				// if (this.$el.querySelector(".tax-project__type")) {
				// 	const taxProjectTypeSlides =
				// 		this.$el.querySelectorAll(".tax-project__type");
				// 	taxProjectTypeSlides.forEach((el) => {
				// 		el.addEventListener("mouseenter", (e) => {
				// 			this.randomizeImg(el);
				// 		});
				// 		el.addEventListener("mouseleave", (e) => {
				// 			this.randomizeImg(el);
				// 		});
				// 	});
				// }
				// if (this.$el.querySelector(".tax-story__collection")) {
				// 	const taxProjectTypeSlides = this.$el.querySelectorAll(
				// 		".tax-story__collection"
				// 	);
				// 	taxProjectTypeSlides.forEach((el) => {
				// 		el.addEventListener("mouseenter", (e) => {
				// 			this.randomizeCollection(el, true);
				// 		});
				// 		el.addEventListener("mouseleave", (e) => {
				// 			this.randomizeCollection(el, false);
				// 		});
				// 	});
				// }
				// if (this.slides) {
				// 	let activeSlide = this.activeIndex;
				// 	let activeSlideClasses = this.slides[activeSlide].classList;
				// 	console.log(activeSlideClasses);
				// }
				// this.swiper.on("init slideChange afterInit", function () {
				// 	let activeSlide = this.activeIndex;
				// 	let activeSlideClasses = this.slides[activeSlide].classList;
				// 	// console.log(activeSlideClasses);
				// 	if (activeSlideClasses.contains("tax-project__type")) {
				// 		scopeThis.setExploreType("explore--dynamic-work");
				// 	} else if (
				// 		activeSlideClasses.contains("tax-story__collection")
				// 	) {
				// 		scopeThis.setExploreType(
				// 			"explore--dynamic-collections"
				// 		);
				// 	} else if (activeSlideClasses.contains("type-story")) {
				// 		scopeThis.setExploreType("explore--dynamic-stories");
				// 	}
				// });
			}
		} else {
		}
	}

	jsScroll(isNext) {
		this.$el
			.querySelector(".swiper-wrapper")
			.classList.add("scrolling-via-js");

		const scopeThis = this;
		if (this.isScrolling) return;
		this.isScrolling = true;

		const distance = isNext ? this.$el.offsetWidth : -this.$el.offsetWidth;

		this.scrollContainer.scrollBy({
			left: distance,
			behavior: "smooth",
		});

		setTimeout(() => {
			scopeThis.isScrolling = false;
			scopeThis.$el
				.querySelector(".swiper-wrapper")
				.classList.remove("scrolling-via-js");
		}, 500);
	}

	randomizeImg(parEl) {
		const imgs = parEl.querySelectorAll("figure img");
		if (imgs === null) return;
		imgs.forEach((img) => {
			img.classList.remove("is-active");
		});
		const randomImg = imgs[Math.floor(Math.random() * imgs.length)];
		if (randomImg) {
			randomImg.classList.add("is-active");
		}
	}

	randomizeCollection(parEl, bool) {
		if (bool) {
			if (parEl.classList.contains("alternate")) {
				parEl.classList.remove("alternate");
			} else {
				parEl.classList.add("alternate");
			}
			const imgs = parEl.querySelectorAll(".rand__stories img");
			const targetEl = parEl.querySelector(".rand__target");
			const imgArr = Array.from(imgs).map((img) => {
				return img.cloneNode(true);
			});

			imgArr.sort(() => Math.random() - 0.5);
			if (imgArr.length > 3) {
				imgArr.splice(3);
			}
			imgArr.forEach((img) => {
				// for each image, generate a random percentage between 0% and 100% for --objtransX variable and same for objtransY variable
				const randomX = Math.floor(Math.random() * 70);
				const randomY = Math.floor(Math.random() * 70);
				img.style.setProperty("--objtransX", randomX - 35 + "%");
				img.style.setProperty("--objtransY", randomY - 35 + "%");
				targetEl.appendChild(img);
			});
		} else {
			// clear the contents of .rand__target
			const targetEl = parEl.querySelector(".rand__target");
			targetEl.innerHTML = "";
		}
		const imgs = parEl.querySelectorAll(".rand__stories img");
		imgs.forEach((img) => {
			if (bool) {
				img.classList.add("is-active");
			} else {
				img.classList.remove("is-active");
			}
		});
	}

	setExploreType(newActive) {
		const exploreHeaders = document.querySelectorAll(
			".home__explore__header"
		);
		exploreHeaders.forEach((el) => {
			const activeEl = el.querySelector(".explore--active");
			if (activeEl) {
				activeEl.classList.remove("explore--active");
			}
			const newActiveEl = el.querySelector(`.${newActive}`);
			if (newActiveEl) {
				newActiveEl.classList.add("explore--active");
			}
		});
	}

	updateButtons() {
		console.log("updateButtons");
		const scopeThis = this;
		if (this.scrollContainer) {
			scopeThis.prevButton.disabled =
				scopeThis.scrollContainer.scrollLeft === 0;
			scopeThis.nextButton.disabled =
				scopeThis.scrollContainer.scrollLeft +
					scopeThis.scrollContainer.clientWidth >=
				scopeThis.scrollContainer.scrollWidth;
		}
	}
}
